import Vue from 'vue'
const that = Vue.prototype
const requestPromisify = function (param) {
    return new Promise((resolve, reject) => {

        var options = {
            url: param.url,
            method:"POST",


            timeout : 30000,
            xhrFields: {
                withCredentials: true
            },


            data: param.data || '',
            success: (res) => {
                if (res.status === 1) {
                    resolve(res)
                } else {
                    reject(res)
                }
            },
            error: (error) => {
                reject({
                    m: '请求errorc'
                })
            }
        };
        that.$J.ajax(options)
    });
}
 export default requestPromisify;


// WEBPACK FOOTER //
// ./src/api/promise.js